export default __webpack_public_path__ + "static/media/template2.28e619ed.jpg";